import { useState } from 'react';

import { NextLink } from '@/atoms';
import { Button, CardOrder } from '@/molecules';
import { Empty } from '@/organisms';

import { routes } from '@/lib/routes';
import { isClosedStatus } from '@/lib/utils';
import { repeat } from '@/stories/utils';

const OrdersList = ({ orders, loading }: any) => {
  const [orderId, setOrderId] = useState<any>(null);
  return loading || (orders && orders?.length > 0) ? (
    <div className="flex flex-col gap-4">
      {loading
        ? repeat(2, <CardOrder loading />)
        : orders.map((order: any) => (
            <CardOrder
              id={order.orderNumber}
              key={order.orderNumber}
              date={order.date}
              price={order?.total}
              status={order.status}
              closed={isClosedStatus(order.status)}
              onClick={(id) => setOrderId(id)}
              buttonLoad={orderId == order.orderNumber}
              {...(order?.sellers && {
                subOrders: [...order.sellers.values()].map((seller: any) => ({
                  seller: seller.name,
                  numItems: seller.numItems,
                  status: seller.status,
                  hasIncidence: seller.showAlert,
                  deliveryDate: seller.estimatedShipping,
                })),
              })}
            />
          ))}
    </div>
  ) : (
    <Empty title="¡VAYA!" text="Todavía no has realizado ningún pedido.">
      <NextLink href={routes.index} passHref>
        <Button as="a">Volver a la tienda</Button>
      </NextLink>
    </Empty>
  );
};

export default OrdersList;
